import React from 'react';
export function PageNotFound() {
  	return (
    	<div>
      		<p>404 Page not found</p>
    	</div>
  	);
}